<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'messages.new' | translate }}
  </div>
  <app-new-message [message]="messageItem()"></app-new-message>
</app-main-dialog>